import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageType } from '../message.model';

@Component({
  selector: 'file360-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})

export class ModalComponent implements OnInit {

  MessageType = MessageType;
  title: string = "";
  message: string = "";
  type: MessageType = MessageType.Information;
  icon: string = "";
  uitype: number = 0;
  txtRight: string = "";
  txtLeft: string = "";
  txtPrimary: string = "";

  constructor(@Inject(MAT_DIALOG_DATA) public modalData: any) {
    this.title = modalData.title;
    this.message = modalData.message;
    this.type = modalData.type;
    this.icon = modalData.icon;
    this.uitype = modalData.uitype;
    this.txtRight = modalData.txtRight;
    this.txtLeft = modalData.txtLeft;
    this.txtPrimary = modalData.txtPrimary;
  }

  ngOnInit() {
  }
}
